export default "__VITE_ASSET__BJIbQU0A__"